import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadingStrategy, PreloadAllModules } from '@angular/router';
// 杨峰的做法是暂时防止未登录的情况下进入了不该进入的路由，其实应该更进一步，需要判断是否由权限进入该路由
import { LoginGuard } from './guard/login.guard';

const routes: Routes = [
  { path: 'landing-page', loadChildren: './landing-page/landing-page.module#LandingPageModule' },
  { path: 'workspace', loadChildren: './workspace/workspace.module#WorkspaceModule', data: { preload: true }, canActivate: [ LoginGuard ] },
  { path: 'market', loadChildren: './market/market.module#MarketModule', canActivate: [ LoginGuard ] },
  { path: 'share', loadChildren: './share/share.module#ShareModule' },
  { path: '', redirectTo: 'landing-page', pathMatch: 'full' },
  { path: '**', redirectTo: 'landing-page', pathMatch: 'full' }
];

@NgModule({
  // useHash 是为了解决刷新404的问题 ，关闭打印路径enableTracing: true,
  imports: [ RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, useHash: true })],
  exports: [ RouterModule ],
  providers: [ LoginGuard ] // LoginGuard 名为路由守卫
})
export class AppRoutingModule {}
